import { render, staticRenderFns } from "./ali.vue?vue&type=template&id=f2f6969c&scoped=true"
import script from "./ali.vue?vue&type=script&lang=js"
export * from "./ali.vue?vue&type=script&lang=js"
import style0 from "./ali.vue?vue&type=style&index=0&id=f2f6969c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f6969c",
  null
  
)

export default component.exports